import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=75d3fc43&scoped=true"
import script from "./Classic.vue?vue&type=script&lang=js"
export * from "./Classic.vue?vue&type=script&lang=js"
import style0 from "./Classic.vue?vue&type=style&index=0&id=75d3fc43&prod&lang=less&scoped=true"
import style1 from "./Classic.vue?vue&type=style&index=1&id=75d3fc43&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d3fc43",
  null
  
)

export default component.exports